import React, { createContext, useContext } from 'react'

import AnalyticsContext from '@/context/analytics'
import ProductionListContext from '@/context/productions-list'

import {
    hiddenByDefaultProductionsWithFormatSelector,
    showProductionsDataSelector,
    visibleByDefaultProductionsWithFormatSelector,
} from './selectors'
import type { ProductionsRowsContextType } from './types'

const ProductionsRowsContext = createContext<ProductionsRowsContextType>(undefined as any)
const { Provider } = ProductionsRowsContext

export const ProductionsRowsProvider: React.FC = ({ children }) => {
    const {
        state: { pageType },
    } = useContext(AnalyticsContext)

    const {
        state: { fetching },
        selectors: {
            productions,
            visibleByDefaultProductions,
            hiddenByDefaultProductions,
            filterParams,
            hasFiltersApplied,
        },
    } = useContext(ProductionListContext)

    const state = { pageType, visibleByDefaultProductions, hiddenByDefaultProductions, fetching }

    return (
        <Provider
            value={{
                state,
                selectors: {
                    productions,
                    visibleByDefaultProductions,
                    visibleByDefaultProductionsWithFormat: visibleByDefaultProductionsWithFormatSelector(state),
                    hiddenByDefaultProductions,
                    hiddenByDefaultProductionsWithFormat: hiddenByDefaultProductionsWithFormatSelector(state),
                    showProductionsData: showProductionsDataSelector(state),
                    filterParams,
                    hasFiltersApplied,
                },
            }}
        >
            {children}
        </Provider>
    )
}

export default ProductionsRowsContext
